import {Add24Regular, Dismiss24Regular} from "@fluentui/react-icons";
import {ChangeEvent, FC, KeyboardEvent, useState} from "react";
import {MemoryItem} from "./intelligenceModels";

interface IntelligenceMemoryViewProps {
    items: MemoryItem[];
    onAdd: (text: string) => void;
    onRemove: (id: string) => void;
}

const IntelligenceMemoryView: FC<IntelligenceMemoryViewProps> = ({
    items,
    onAdd,
    onRemove
}) => {
    const [draft, setDraft] = useState("");

    const commit = (): void => {
        const trimmed = draft.trim();
        if (trimmed.length === 0) {
            return;
        }
        onAdd(trimmed);
        setDraft("");
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setDraft(event.target.value);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === "Enter") {
            event.preventDefault();
            commit();
        }
    };

    return (
        <div className="pi-scroll">
            <div className="pi-view-head">
                <h2 className="pi-view-head__title">Memory</h2>
                <p className="pi-view-head__desc">
                    What PAR Intelligence remembers to personalize every answer.
                </p>
            </div>

            <div className="pi-memory__add">
                <input
                    type="text"
                    className="pi-memory__input"
                    placeholder="Teach PAR Intelligence something new…"
                    value={draft}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />
                <button
                    type="button"
                    className="pi-btn pi-btn--primary"
                    onClick={commit}
                >
                    <Add24Regular />
                    Add
                </button>
            </div>

            {items.map((item) => (
                <div className="pi-memory-item" key={item.id}>
                    <div className="pi-memory-item__body">
                        <span className="pi-memory-item__cat">
                            {item.category}
                        </span>
                        <div className="pi-memory-item__text">{item.text}</div>
                        <div className="pi-memory-item__source">{item.source}</div>
                    </div>
                    <button
                        type="button"
                        className="pi-memory-item__remove"
                        aria-label="Forget this"
                        onClick={() => onRemove(item.id)}
                    >
                        <Dismiss24Regular />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default IntelligenceMemoryView;
